<template>
  <transition name="fade">
    <b-container v-if="credits">
      <b-row>
        <b-col class="p-0 mt-5"
          ><h4 class="font-weight-bold">Vellos Ready</h4></b-col
        >
      </b-row>

      <b-row class="mr-n4" v-if="credits.length > 0">
        <b-col
          v-for="(credit, index) in credits"
          :key="index"
          class="overflow-hidden text-center p-0 mt-4 mb-2 mr-1 ml-n1 ml-sm-n3 ml-md-n4 cursor"
          cols="4"
          md="3"
          lg="2"
        >
          <b-link
            :to="
              `/influencer/` +
              credit.influencer_profile.influencer_uid +
              `/` +
              credit.influencer_profile.username
            "
          >
            <b-badge
              ref="badge"
              variant="danger"
              class="credit-label"
              v-if="credit.question_credits"
              v-text="credit.question_credits.total_available_credits"
            />
            <div
              class="rounded-circle photo-width border border-1"
              :style="
                `border-color: ` +
                credit.influencer_profile.avatar_border_hex +
                ` !important;`
              "
            >
              <div
                class="rounded-circle photo-width-img"
                v-if="credit.influencer_profile"
                :style="
                  `background:url(` +
                  credit.influencer_profile.profile_photo_url +
                  `) center/cover;`
                "
              />
            </div>
          </b-link>
          <small
            class="grey-light d-block"
            v-if="credit.influencer_profile"
            v-text="`@` + credit.influencer_profile.username"
          />
        </b-col>

        <b-col
          v-if="has_more"
          class="ml-n2 ml-sm-n3 ml-md-n5 p-4 m-auto text-center"
          cols="12"
        >
          <a href="javascript:;" @click="loadVellos">
            <b-spinner v-if="loading" small class="mr-2" />
            <small>show more +</small>
          </a>
        </b-col>
      </b-row>

      <b-row v-else>
        <b-col class="p-0 mt-5 text-center">
          <a class="align-middle" href="#">
            <small>
              No vellos yet, purchase now
              <b-img
                src="~@/assets/img/next.png"
                height="15px"
                class="pl-1"
                alt="arrow"
              />
            </small>
          </a>
        </b-col>
      </b-row>
    </b-container>
  </transition>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
export default {
  name: 'VelloCredits',

  data() {
    return {
      loading: false,
      limit: 12,
      page: 1,
    }
  },

  computed: {
    ...mapState({
      credits: (state) => state.question.credits,
      has_more: (state) => state.question.has_more,
    }),

    params() {
      return {
        limit: this.limit,
        page: this.page,
      }
    },
  },

  methods: {
    ...mapActions({
      getVellos: 'question/getVellos',
    }),
    ...mapMutations({
      clearVellos: 'question/clearVellos',
    }),

    async loadVellos() {
      this.loading = true

      await this.getVellos(this.params)

      this.loading = false
      this.page++
    },

    isToRenewInaWeek(credit) {
      return !!(
        credit &&
        credit.question_credits &&
        credit.question_credits.monthly_credits_days_remaining > 0 &&
        credit.question_credits.monthly_credits_days_remaining <= 7
      )
    },
  },

  created() {
    this.loadVellos()
  },

  async destroyed() {
    await this.clearVellos()
  },
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/abstract/variables';
@import '../../assets/scss/base/_mixins';

.photo-width {
  width: 85%;
  margin: auto;
  padding: 4px;

  @include respond-above(xs) {
    width: 80%;
  }
  @include respond-above(sm) {
    width: 75%;
  }

  .photo-width-img {
    padding: 50%;
  }
}

.credit-label {
  background: $brand;
  border-radius: 0.65rem;
  bottom: -2px;
  float: right;
  font-size: 15px;
  font-weight: 700;
  min-height: 30px;
  min-width: 35px;
  padding: 0.5rem;
  position: relative;
  right: 12px;

  @include respond-above(xs) {
    bottom: -4px;
    right: 15px;
  }
  @include respond-above(sm) {
    bottom: -5px;
    right: 20px;
  }
  @include respond-above(md) {
    bottom: -6px;
    right: 25px;
  }
  @include respond-above(lg) {
    bottom: -7px;
  }
}

.credit-warning {
  background: rgba(255, 0, 88, 0.2);
  border-radius: 0.7rem;
  width: 90px;
  color: #ff0058;
  margin: auto;
  line-height: 10px;
  padding: 4px 0;
  margin-top: 4px;
}
</style>
